import { z } from "zod";

export type SpirometerID = `SM-${number}${number}${number}-Z${number}${number}${number}${number}${number}${number}`;
export const spirometerIDRegex = /^SM-005-Z\d\d\d\d\d\d$/;
export const spirometerIDSchema = z.custom<SpirometerID>(data => typeof data === 'string' && spirometerIDRegex.test(data));

export type SpirobankSmart2ID = `spirobank_${number}${number}${number}${number}${number}`;
export const spirobankSmart2IDSchema = z.custom<SpirobankSmart2ID>(data => typeof data === 'string' && /^spirobank_\d\d\d\d\d$/.test(data));

export const fenoDeviceSerialNumberLength = 9;
export const fenoDeviceSerialNumberRegex = new RegExp(`^\\d{${fenoDeviceSerialNumberLength}}$`);
export const fenoDeviceSerialNumberSchema = z
  .string()
  .trim()
  .refine((s): s is `${number}${number}${number}${number}${number}${number}${number}${number}${number}` => fenoDeviceSerialNumberRegex.test(s));
export type FenoDeviceSerialNumber = z.infer<typeof fenoDeviceSerialNumberSchema>;

export const noBreathFenoDeviceSerialNumberRegex = /^NN\d{6}$/;
export const noBreathFenoDeviceSerialNumberSchema = z
  .string()
  .trim()
  .refine((s): s is `NN${number}${number}${number}${number}${number}${number}` => noBreathFenoDeviceSerialNumberRegex.test(s));
export type NoBreathFenoDeviceSerialNumber = z.infer<typeof noBreathFenoDeviceSerialNumberSchema>;
